import { DISPLAY_NAME, useContentContext } from '../../content'
import type { ContentScopedProps } from '../../content.types'
import { ContentActionsVariants } from './content-actions.styles'

type ContentActionsProps = {
  children: React.ReactNode
}

export function ContentActions(props: ContentActionsProps) {
  const { children, __scopeContent } =
    props as ContentScopedProps<ContentActionsProps>

  const { variants } = useContentContext(DISPLAY_NAME, __scopeContent)

  if (variants !== 'title') {
    return
  }

  return (
    <div className={ContentActionsVariants()} data-testid="content-actions">
      {children}
    </div>
  )
}
